var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      ref: "form",
      attrs: { action: _vm.action, method: "POST" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "form-group",
        {
          attrs: {
            label: "Naam",
            name: "name",
            isEditMode: _vm.isEditMode,
            isDisabled: _vm.isSubmitting,
            isValid: !_vm.$v.contacts.name.$invalid,
            contacts: _vm.contacts,
          },
        },
        [
          !_vm.$v.contacts.name.required
            ? _c("error-warning", [
                _vm._v(
                  "\n            Incorrect name. This field is required.\n        "
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "form-group",
        {
          attrs: {
            label: "Telefoon",
            name: "phone",
            isEditMode: _vm.isEditMode,
            isDisabled: _vm.isSubmitting,
            isValid: !_vm.$v.contacts.phone.$invalid,
            contacts: _vm.contacts,
          },
        },
        [
          !_vm.$v.contacts.phone.required
            ? _c("error-warning", [
                _vm._v(
                  "\n            Incorrect phone address. This field is required.\n        "
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "form-group",
        {
          attrs: {
            label: "E-mailadres",
            name: "email",
            isEditMode: _vm.isEditMode,
            isDisabled: _vm.isSubmitting,
            isValid: !_vm.$v.contacts.email.$invalid,
            contacts: _vm.contacts,
          },
        },
        [
          !_vm.$v.contacts.email.required
            ? _c("error-warning", [
                _vm._v(
                  "\n            Incorrect email address. This field is required.\n        "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.$v.contacts.email.email
            ? _c("error-warning", [
                _vm._v("\n            Invalid email address.\n        "),
              ])
            : _vm._e(),
          _vm._v(" "),
          this.invalidEmail
            ? _c("error-warning", [
                _vm._v(
                  "\n            " + _vm._s(this.invalidEmail) + "\n        "
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "form-group",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: this.isEmailChanged(),
              expression: "this.isEmailChanged()",
            },
          ],
          attrs: {
            label: "Huidig wachtwoord",
            name: "password",
            type: "password",
            isEditMode: _vm.isEditMode,
            isDisabled: _vm.isSubmitting,
            isValid: this.isEmailChanged() && !!this.contacts.password,
            contacts: _vm.contacts,
          },
        },
        [
          this.isEmptyPassword
            ? _c("error-warning", [
                _vm._v("\n      Het veld is verplicht\n    "),
              ])
            : _vm._e(),
          _vm._v(" "),
          this.invalidPassword
            ? _c("error-warning", [
                _vm._v("\n      " + _vm._s(this.invalidPassword) + "\n    "),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isEditMode
        ? _c(
            "button",
            {
              staticClass: "button order medium fullwidth",
              attrs: { disabled: _vm.isSubmitting },
            },
            [
              _c("span", [_vm._v("Save")]),
              _vm._v(" "),
              _c("div", {
                class: { "button-spinner": true, hidden: !_vm.isSubmitting },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isEditMode
        ? _c(
            "button",
            {
              staticClass: "button medium fullwidth",
              attrs: { type: "button" },
              on: { click: _vm.cancel },
            },
            [_vm._v("\n        Cancel\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "spacingMedium" }),
      _vm._v(" "),
      !_vm.isEditMode
        ? _c("div", { staticClass: "edit" }, [
            _c(
              "a",
              {
                attrs: { href: _vm.href },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.toggleEditMode.apply(null, arguments)
                  },
                },
              },
              [_vm._v("\n            Change address\n        ")]
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [_c("strong", [_vm._v("Contact information")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }